import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TakeawayServices } from '../services';
import moment from 'moment';
/**
 * Generated class for the KitchenDeleteOrdersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-takeaway-old-delete-orders',
  templateUrl: 'takeaway-old-delete-orders.html',
})




export class TakeawayOldDeleteOrdersPage {

  loadingPopup: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public translate: TranslateService,
    public loadingCtrl: LoadingController,
    public http: HttpClient,
    public takeawayServices: TakeawayServices) {
    //init


  }

  ionViewWillEnter() {
    //calcular el tiempo aproximado a borrar
    var countOldOrders = this.takeawayServices.old_orders.length;
    var timePerOrder = 0.5;
    var totalSeconds = (countOldOrders * timePerOrder);
    var m = Math.floor(totalSeconds % 3600 / 60);
    var s = Math.floor(totalSeconds % 3600 % 60);
    var timeFormat="00:" + m + ":" + s;
    var total2Wait = this.translate.instant('general-tiempo') +": " + moment(timeFormat,'HH:mm:ss').format('HH:mm:ss');
    //present loading
    this.loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: `
      <div class="custom-spinner-container">
        <div class="custom-spinner-box">
        <h4>`+ this.translate.instant('general-borrando').toUpperCase() + ' ' + this.translate.instant('general-pedidos').toUpperCase() + `<h4>
        <p>`+ total2Wait + `</p>
        </div>
      </div>`,
    });
    this.loadingPopup.present();
    //delete orders in node
    this.deleteOldOrdersFromNode();
  }

  async deleteOldOrdersFromNode() {
    await this.http.post(this.globals.analytics_path + 'takeaway/delete_old_orders', { old_orders: this.takeawayServices.old_orders }, {}).toPromise();
    this.loadingPopup.dismiss();
    this.navCtrl.pop();
  }

  onBack() {
    this.navCtrl.pop();
  }

}


// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-old-delete-orders/takeaway-old-delete-orders.ts